/**
 * Service for area creation operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import {
  mapCreateAreaFromTransport,
  mapCreateAreaToTransport,
} from '../mappers';
import type {
  CreateAreaRequest,
  CreateAreaResult,
  LC_CreateCompanyAreaOut,
} from '../types';


export class AreaCreateService {
  /**
   * Create a new area
   *
   * Response codes:
   * - 200: Area created successfully
   * - 400: Validation error (VALIDATION_ERROR)
   * - 409: Conflict - duplicate area code (CONFLICT)
   * - 500: Internal server error
   */
  async create(
    request: CreateAreaRequest,
  ): Promise<ApiResponse<CreateAreaResult>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.AREAS;
    const payload = mapCreateAreaToTransport(request);

    const response = await apiClient.post<LC_CreateCompanyAreaOut>(
      endpoint,
      payload,
    );

    if (response.success && response.data) {
      return {
        ...response,
        data: mapCreateAreaFromTransport(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const areaCreate = new AreaCreateService();
